"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = exports.MODAL_SIZES = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _Modal = _interopRequireDefault(require("react-overlays/Modal"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _tabbable = require("tabbable");
var _isReactFragment = require("../utils/isReactFragment");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _AlertDialogContext = require("../utils/_AlertDialogContext");
var _focusManager = require("../utils/focusManager");
var _ModalManagerContext = require("../utils/_ModalManagerContext");
var _useModalManager = require("../utils/useModalManager");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _useUniqueId = require("../utils/useUniqueId");
var _Fade = require("./_Fade");
var _ModalBody = require("./_ModalBody");
var _ModalFooter = require("./_ModalFooter");
var _ModalHeader = require("./_ModalHeader");
var _ModalSubhead = require("./_ModalSubhead");
var _ModalTitle = require("./_ModalTitle");
var _Modal2 = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
var _excluded = ["backdropClassName", "className", "children", "customFocusManager", "containerClassName", "draggable", "modalContainerClassName", "modalContainerProps", "modalContentProps", "fullscreen", "isModal", "onHide", "onShow", "resizable", "show", "size"];
/* eslint-disable react/no-multi-comp */
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-modal';
var MODAL_SIZES = exports.MODAL_SIZES = ['lg', 'md', 'sm', 'xl'];

/**
 * The **Modal** component acts as a dialog box overlaid on top of the page. This allows the user
 * to focus on specific content before returning to the underlying application page.
 *
 * **Modal** consists of a header component (with or without a close box), a title
 * component, a body component, and a footer component (plus an optional subheading
 * component below the title).
 */

var Modal = exports.Modal = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _context;
  var alertDialog = (0, _react.useContext)(_AlertDialogContext.AlertDialogContext);
  var titleId = (0, _useUniqueId.useUniqueId)();
  var subheadId = (0, _useUniqueId.useUniqueId)();
  var bodyId = (0, _useUniqueId.useUniqueId)();
  var subHeaderExists = (0, _react.useRef)(false);
  var ariaTitleId = (0, _react.useRef)(titleId);
  var ariaSubheadId = (0, _react.useRef)(subheadId);
  var ariaBodyId = (0, _react.useRef)(bodyId);
  var backdropClassName = props.backdropClassName,
    className = props.className,
    children = props.children,
    customFocusManager = props.customFocusManager,
    containerClassName = props.containerClassName,
    draggable = props.draggable,
    modalContainerClassName = props.modalContainerClassName,
    modalContainerProps = props.modalContainerProps,
    modalContentProps = props.modalContentProps,
    fullscreen = props.fullscreen,
    _props$isModal = props.isModal,
    isModal = _props$isModal === void 0 ? true : _props$isModal,
    onHide = props.onHide,
    onShow = props.onShow,
    resizable = props.resizable,
    show = props.show,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Modal2.default);
  var containerRef = (0, _react.useRef)();
  var mergedContainerRef = (0, _reactMergeRefs.default)([containerRef, modalContainerProps === null || modalContainerProps === void 0 ? void 0 : modalContainerProps.ref]);
  var modalRef = (0, _react.useRef)();
  var mergedRef = (0, _reactMergeRefs.default)([ref, modalRef]);
  var contentRef = (0, _react.useRef)();
  var mergedContentRef = (0, _reactMergeRefs.default)([contentRef, modalContentProps === null || modalContentProps === void 0 ? void 0 : modalContentProps.ref]);
  var modalManager = (0, _useModalManager.useModalManager)();
  var modalContentId = (0, _useUniqueId.useUniqueId)();
  if (modalContentProps !== null && modalContentProps !== void 0 && modalContentProps.id) {
    modalContentId = modalContentProps.id;
  }
  var modalClasses = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--fullscreen"), fullscreen));
  var modalContainerClasses = classnames("".concat(CSS_BLOCK, "__container"), modalContainerClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__container--")).call(_context, size), size !== 'md'), "".concat(CSS_BLOCK, "__container--non-modal"), !isModal));
  var containerClasses = classnames(containerClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__open"), isModal), "".concat(CSS_BLOCK, "__open--non-modal"), !isModal));
  var backdropClasses = classnames("".concat(CSS_BLOCK, "__backdrop"), backdropClassName, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__backdrop--fullscreen"), fullscreen));
  var _handleFocusManager = function _handleFocusManager() {
    if (alertDialog) {
      if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
        var dialog = modalRef.current.dialog;

        // eslint-disable-next-line no-unused-expressions
        dialog && new _focusManager.FocusManager({
          trapNode: dialog,
          suppressInitialAttachment: true
        });
      }
    } else if (customFocusManager) {
      customFocusManager();
    } else if (isModal) {
      setTimeout(function () {
        if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
          var _dialog = modalRef.current.dialog;

          // focus first focusable element in modal body
          var firstFocusIndex = 0;
          var closeButtonExists = false;
          _react.default.Children.forEach(children, function (child) {
            var _child$type, _child$type2;
            if ((child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === _ModalHeader.ModalHeader.displayName) {
              if (child.props.closeButton) {
                closeButtonExists = true;
              }
            } else if ((child === null || child === void 0 || (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === _ModalBody.ModalBody.displayName) {
              var bodyNode = _dialog === null || _dialog === void 0 ? void 0 : _dialog.querySelector("[data-nui-widgets=\"".concat(_ModalBody.ModalBody.displayName, "\"]"));
              if (bodyNode && (0, _tabbable.tabbable)(bodyNode).length > 0 && (closeButtonExists || draggable)) {
                if (closeButtonExists) firstFocusIndex += 1;
                if (draggable) firstFocusIndex += 1;
              }
            }
          });

          // eslint-disable-next-line no-unused-expressions
          _dialog && new _focusManager.FocusManager({
            trapNode: _dialog,
            firstFocusIndex: firstFocusIndex
          });
        }
      }, 500); // needs to match the delay in DataGrid to ensure gridManager is loaded
    }
  };
  var dialogTransitionRef = (0, _react.useRef)(function (transitionProps) {
    return /*#__PURE__*/_react.default.createElement(_Fade.Fade, (0, _extends2.default)({
      isModal: isModal
    }, transitionProps));
  });
  var backdropTransitionRef = (0, _react.useRef)(function (transitionProps) {
    return /*#__PURE__*/_react.default.createElement(_Fade.Fade, (0, _extends2.default)({
      isModal: isModal,
      timeout: 150
    }, transitionProps));
  });
  var passChildProps = function passChildProps(child) {
    if (child.displayName === 'DataGrid') {
      return {
        backgroundType: 'panel'
      };
    }
    return null;
  };
  var alterHeaderChildren = function alterHeaderChildren(childNodes) {
    return _react.default.Children.forEach(childNodes, function (modalHeaderChild) {
      var _modalHeaderChild$typ, _modalHeaderChild$typ2;
      if ((0, _isReactFragment.isReactFragment)(modalHeaderChild)) {
        var _modalHeaderChild$pro;
        alterHeaderChildren(modalHeaderChild === null || modalHeaderChild === void 0 || (_modalHeaderChild$pro = modalHeaderChild.props) === null || _modalHeaderChild$pro === void 0 ? void 0 : _modalHeaderChild$pro.children);
      }
      if ((modalHeaderChild === null || modalHeaderChild === void 0 || (_modalHeaderChild$typ = modalHeaderChild.type) === null || _modalHeaderChild$typ === void 0 ? void 0 : _modalHeaderChild$typ.displayName) === 'Modal.Title') {
        ariaTitleId.current = modalHeaderChild.props.id || ariaTitleId.current;
      } else if ((modalHeaderChild === null || modalHeaderChild === void 0 || (_modalHeaderChild$typ2 = modalHeaderChild.type) === null || _modalHeaderChild$typ2 === void 0 ? void 0 : _modalHeaderChild$typ2.displayName) === 'Modal.Subhead') {
        ariaSubheadId.current = modalHeaderChild.props.id || ariaSubheadId.current;
        subHeaderExists.current = true;
      }
    });
  };
  var statefulChildren = (0, _react.useMemo)(function () {
    var _context2;
    return (0, _map.default)(_context2 = _react.default.Children).call(_context2, children, function (child) {
      var _child$type3, _child$type4, _child$type5;
      if ((child === null || child === void 0 || (_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName) === _ModalHeader.ModalHeader.displayName) {
        alterHeaderChildren(child === null || child === void 0 ? void 0 : child.props.children);
        return /*#__PURE__*/_react.default.cloneElement(child, {
          titleId: ariaTitleId.current,
          // passthrough to Modal.Title component
          subheadId: ariaSubheadId.current,
          // passthrough to Modal.Header component
          onHide: onHide,
          className: classnames((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__header--subheader"), subHeaderExists.current), child.props.className),
          draggable: draggable && !fullscreen ? draggable : undefined,
          updateStyle: function updateStyle(styleValue) {
            if (containerRef !== null && containerRef !== void 0 && containerRef.current) {
              containerRef.current.style.top = styleValue.top;
              containerRef.current.style.left = styleValue.left;
              containerRef.current.style.margin = 'auto';
            }
          },
          containerRef: containerRef,
          modalContentId: modalContentId
        });
      }
      if ((child === null || child === void 0 || (_child$type4 = child.type) === null || _child$type4 === void 0 ? void 0 : _child$type4.displayName) === _ModalBody.ModalBody.displayName) {
        var _child$props;
        ariaBodyId.current = (child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id) || ariaBodyId.current;
        return /*#__PURE__*/_react.default.cloneElement(child, {
          id: ariaBodyId.current,
          isResizable: !!resizable
        });
      }
      if ((child === null || child === void 0 || (_child$type5 = child.type) === null || _child$type5 === void 0 ? void 0 : _child$type5.displayName) === _ModalFooter.ModalFooter.displayName) {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          resizable: resizable && !fullscreen ? resizable : undefined,
          updateStyle: function updateStyle(styleValue) {
            if (contentRef !== null && contentRef !== void 0 && contentRef.current) {
              contentRef.current.style.height = styleValue.height;
              contentRef.current.style.width = styleValue.width;
              containerRef.current.style.marginBottom = 'auto';
            }
          },
          contentRef: contentRef,
          modalContentId: modalContentId
        });
      }
      return child;
    });
  }, [children, draggable, fullscreen, resizable, modalContentId]);
  var ariaDescribedBy;
  if (alertDialog) {
    ariaDescribedBy = ariaBodyId.current;
  } else if (subHeaderExists.current) {
    ariaDescribedBy = ariaSubheadId.current;
  }
  return /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({}, otherProps, {
    "aria-describedby": ariaDescribedBy,
    "aria-labelledby": otherProps['aria-labelledby'] || ariaTitleId.current,
    backdrop: isModal ? 'static' : false,
    backdropTransition: backdropTransitionRef.current,
    className: modalClasses,
    containerClassName: containerClasses,
    enforceFocus: false,
    manager: modalManager,
    onHide: onHide,
    onShow: (0, _chainFunction.default)(_handleFocusManager, onShow),
    ref: mergedRef,
    renderBackdrop: function renderBackdrop() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: backdropClasses
      });
    },
    role: alertDialog ? 'alertdialog' : undefined,
    show: show,
    transition: dialogTransitionRef.current
  }), /*#__PURE__*/_react.default.createElement(_ModalManagerContext.ModalManagerContext.Provider, {
    value: modalManager
  }, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, modalContainerProps, {
    className: modalContainerClasses,
    ref: mergedContainerRef
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, modalContentProps, {
    id: modalContentId,
    className: classnames("".concat(CSS_BLOCK, "__content"), modalContentProps === null || modalContentProps === void 0 ? void 0 : modalContentProps.className),
    role: "document",
    ref: mergedContentRef,
    "data-nui-widgets": "modal-content"
  }), statefulChildren)))));
});
Modal.displayName = 'Modal';
Modal.propTypes = _objectSpread(_objectSpread({}, _Modal.default.propTypes), {}, {
  /** Custom classes to add to the **Modal** backdrop’s `<div>` tag. */
  backdropClassName: _propTypes.default.string,
  /** The content of the **Modal** specifically the `Modal.Header`,
   * `Modal.Title`, `Modal.Subhead`, `Modal.Body` and/or `Modal.Footer`. */
  children: _propTypes.default.node,
  /** Custom classes to add to the **Modal** component's outermost `<div>` tag. */
  className: _propTypes.default.string,
  /** Custom classes applied to the modal container (`<body>` by default)
   * when the modal is open, and removed when it is closed. */
  containerClassName: _propTypes.default.string,
  /** Properties to enable ability to drag the **Modal** to another position by
   * clicking and holding (or focusing and using arrow keys) on the **Modal.Header**.
   *
   * `screenReaderInstruction` (string): Assistive text communicated to screen
   * reader users when **Modal.Header** is focused and draggable is enabled.
   * Use `CoreUIComponents.draggableModal`.
   *
   * `onDragStart` (func): Callback for start of drag event (mouse only).
   *
   * `onDragEnd` (func): Callback for end of drag event (mouse only).
   *
   * `onKeyDown` (func): Callback for keydown event on **Modal.Header**.
   * */
  draggable: _propTypes.default.shape({
    screenReaderInstructions: _CustomPropTypes.default.localizedString('CoreUIComponents.draggableModal').isRequired,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** When true, the **Modal** will take up the majority of the browser window,
   * obscuring underlying content. */
  fullscreen: _propTypes.default.bool,
  /** Determines whether the dialog is a modal. Renders a backdrop and traps focus. */
  isModal: _propTypes.default.bool,
  /** Custom classes to add to the **Modal** content’s outermost `<div>` tag. */
  modalContainerClassName: _propTypes.default.string,
  /** Props to spread to the **Modal** content’s outermost `<div>` tag. */
  modalContainerProps: _propTypes.default.object,
  /** Props to spread to the **Modal** content’s inner `<div>` tag. */
  modalContentProps: _propTypes.default.object,
  /** Properties to enable ability to resize the **Modal** by clicking
   * and holding (or focusing and using arrow keys) on the resizing handle
   * in **Modal.Footer**.
   *
   * `handleLabel` (string): Provides an accessible label for the resizing handle.
   * Use `CoreUIComponents.resizableModal`.
   *
   * `height` (number): initial height for the modal in pixels.
   *
   * `width` (number): initial width for the modal in pixels.
   *
   * `maxHeight` (number): Maximum height for the modal in pixels.
   *
   * `maxWidth` (number): Maximum width for the modal in pixels.
   *
   * `minHeight` (number): Minimum height for the modal in pixels.
   *
   * `minWidth` (number): Minimum width for the modal in pixels.
   *
   * `onDragStart` (func): Callback for start of drag event (mouse only).
   *
   * `onDragEnd` (func): Callback for end of drag event (mouse only).
   *
   * `onKeyDown` (func): Callback for keydown event on resizing handle in **Modal.Footer**.
   * */
  resizable: _propTypes.default.shape({
    handleLabel: _CustomPropTypes.default.localizedString('CoreUIComponents.resizableModal').isRequired,
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    maxHeight: _propTypes.default.number,
    maxWidth: _propTypes.default.number,
    minHeight: _propTypes.default.number,
    minWidth: _propTypes.default.number,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** Size of the **Modal**. Options are 'xl', 'lg', 'md', 'sm'. */
  size: _propTypes.default.oneOf(MODAL_SIZES),
  /** Internal use only */
  customFocusManager: _propTypes.default.func
});
Modal.Body = _ModalBody.ModalBody;
Modal.Header = _ModalHeader.ModalHeader;
Modal.Title = _ModalTitle.ModalTitle;
Modal.Footer = _ModalFooter.ModalFooter;
Modal.Subhead = _ModalSubhead.ModalSubhead;
var _default = exports.default = Modal;